import { Compass, TriangleAlert } from "lucide-react";
import { Link, useRouteError } from "react-router";
import { Button } from "../../components/ui/button";
import { EmptyState } from "../../components/ui/feedback";

export function NotFoundPage() {
  return (
    <EmptyState
      icon={<Compass aria-hidden className="size-6" strokeWidth={1.5} />}
      title="We couldn't find that page"
      action={
        <Link to="/" className="font-semibold text-brand-fg underline-offset-4 hover:underline">
          Go to Home
        </Link>
      }
    >
      The link may be old, or the page may need a role you don't have.
    </EmptyState>
  );
}

/** Shown when a page crashes while rendering. Keeps the person in the app with a way out. */
export function RouteErrorPage() {
  const error = useRouteError();
  if (import.meta.env.DEV) console.error(error);
  return (
    <div className="grid min-h-dvh place-items-center bg-canvas px-4">
      <EmptyState
        icon={<TriangleAlert aria-hidden className="size-6" strokeWidth={1.5} />}
        title="Something went wrong on this page"
        action={<Button onClick={() => window.location.reload()}>Reload the page</Button>}
      >
        Your work was not lost on the server. Reloading usually fixes this.
      </EmptyState>
    </div>
  );
}
